// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contribution-calendar {
  background: #1a1b23;
  border: 1px solid #30363d;
  border-radius: 12px;
  padding: 24px;
  margin: 24px 0;
  color: #c9d1d9;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.calendar-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #c9d1d9;
}

.contribution-settings {
  font-size: 12px;
  color: #7d8590;
  cursor: pointer;
}

.contribution-settings:hover {
  color: #58a6ff;
}

.calendar-container {
  position: relative;
}

.month-labels {
  display: grid;
  grid-template-columns: repeat(53, 11px);
  gap: 3px;
  margin-bottom: 8px;
  margin-left: 30px;
  overflow: visible;
}

.month-label {
  font-size: 10px;
  color: #7d8590;
  text-align: left;
  white-space: nowrap;
  overflow: visible;
  min-width: 11px;
}

.calendar-content {
  display: flex;
  gap: 8px;
}

.day-labels {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 98px;
  font-size: 9px;
  color: #7d8590;
  width: 22px;
}

.day-label {
  line-height: 1;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(53, 11px);
  gap: 3px;
}

.calendar-week {
  display: grid;
  grid-template-rows: repeat(7, 11px);
  gap: 3px;
}

.calendar-day {
  width: 11px;
  height: 11px;
  border-radius: 2px;
  cursor: pointer;
  outline: 1px solid rgba(27, 31, 36, 0.06);
  outline-offset: -1px;
}

/* Уровни активности как на GitHub */
.calendar-day.level-0 {
  background-color: #161b22;
}

.calendar-day.level-1 {
  background-color: #0e4429;
}

.calendar-day.level-2 {
  background-color: #006d32;
}

.calendar-day.level-3 {
  background-color: #26a641;
}

.calendar-day.level-4 {
  background-color: #39d353;
}

.calendar-day:hover {
  outline: 1px solid rgba(255, 255, 255, 0.3);
  outline-offset: -1px;
}

.calendar-legend {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 8px;
  font-size: 10px;
  color: #7d8590;
}

.legend-squares {
  display: flex;
  gap: 2px;
  margin: 0 4px;
}

.legend-square {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  outline: 1px solid rgba(27, 31, 36, 0.06);
  outline-offset: -1px;
}

.legend-text {
  font-size: 10px;
  color: #7d8590;
}

/* Адаптивность */
@media (max-width: 768px) {
  .contribution-calendar {
    padding: 16px;
    overflow-x: auto;
  }
  
  .calendar-container {
    min-width: 650px;
  }
  
  .calendar-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .contribution-calendar {
    padding: 12px;
    margin: 16px 0;
  }
  
  .calendar-header h3 {
    font-size: 12px;
  }
}

/* Loading and Error States */
.loading-skeleton {
  height: 120px;
  background: linear-gradient(90deg, #1a1b23 25%, #2a2b33 50%, #1a1b23 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 8px;
}

.skeleton-grid {
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
    90deg,
    #161b22 0px,
    #161b22 11px,
    transparent 11px,
    transparent 14px
  );
  opacity: 0.3;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.error-message {
  color: #f85149;
  text-align: center;
  padding: 20px;
  font-size: 14px;
} `, "",{"version":3,"sources":["webpack://./src/components/ContributionCalendar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,YAAY;AACd;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB","sourcesContent":[".contribution-calendar {\n  background: #1a1b23;\n  border: 1px solid #30363d;\n  border-radius: 12px;\n  padding: 24px;\n  margin: 24px 0;\n  color: #c9d1d9;\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.calendar-header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #c9d1d9;\n}\n\n.contribution-settings {\n  font-size: 12px;\n  color: #7d8590;\n  cursor: pointer;\n}\n\n.contribution-settings:hover {\n  color: #58a6ff;\n}\n\n.calendar-container {\n  position: relative;\n}\n\n.month-labels {\n  display: grid;\n  grid-template-columns: repeat(53, 11px);\n  gap: 3px;\n  margin-bottom: 8px;\n  margin-left: 30px;\n  overflow: visible;\n}\n\n.month-label {\n  font-size: 10px;\n  color: #7d8590;\n  text-align: left;\n  white-space: nowrap;\n  overflow: visible;\n  min-width: 11px;\n}\n\n.calendar-content {\n  display: flex;\n  gap: 8px;\n}\n\n.day-labels {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  height: 98px;\n  font-size: 9px;\n  color: #7d8590;\n  width: 22px;\n}\n\n.day-label {\n  line-height: 1;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(53, 11px);\n  gap: 3px;\n}\n\n.calendar-week {\n  display: grid;\n  grid-template-rows: repeat(7, 11px);\n  gap: 3px;\n}\n\n.calendar-day {\n  width: 11px;\n  height: 11px;\n  border-radius: 2px;\n  cursor: pointer;\n  outline: 1px solid rgba(27, 31, 36, 0.06);\n  outline-offset: -1px;\n}\n\n/* Уровни активности как на GitHub */\n.calendar-day.level-0 {\n  background-color: #161b22;\n}\n\n.calendar-day.level-1 {\n  background-color: #0e4429;\n}\n\n.calendar-day.level-2 {\n  background-color: #006d32;\n}\n\n.calendar-day.level-3 {\n  background-color: #26a641;\n}\n\n.calendar-day.level-4 {\n  background-color: #39d353;\n}\n\n.calendar-day:hover {\n  outline: 1px solid rgba(255, 255, 255, 0.3);\n  outline-offset: -1px;\n}\n\n.calendar-legend {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: 8px;\n  font-size: 10px;\n  color: #7d8590;\n}\n\n.legend-squares {\n  display: flex;\n  gap: 2px;\n  margin: 0 4px;\n}\n\n.legend-square {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  outline: 1px solid rgba(27, 31, 36, 0.06);\n  outline-offset: -1px;\n}\n\n.legend-text {\n  font-size: 10px;\n  color: #7d8590;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .contribution-calendar {\n    padding: 16px;\n    overflow-x: auto;\n  }\n  \n  .calendar-container {\n    min-width: 650px;\n  }\n  \n  .calendar-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .contribution-calendar {\n    padding: 12px;\n    margin: 16px 0;\n  }\n  \n  .calendar-header h3 {\n    font-size: 12px;\n  }\n}\n\n/* Loading and Error States */\n.loading-skeleton {\n  height: 120px;\n  background: linear-gradient(90deg, #1a1b23 25%, #2a2b33 50%, #1a1b23 75%);\n  background-size: 200% 100%;\n  animation: loading 1.5s infinite;\n  border-radius: 8px;\n}\n\n.skeleton-grid {\n  width: 100%;\n  height: 100%;\n  background: repeating-linear-gradient(\n    90deg,\n    #161b22 0px,\n    #161b22 11px,\n    transparent 11px,\n    transparent 14px\n  );\n  opacity: 0.3;\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.error-message {\n  color: #f85149;\n  text-align: center;\n  padding: 20px;\n  font-size: 14px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
